import { Users, Download } from "lucide-react";
import axios from "axios";
import { API } from "../../App";
import { toast } from "sonner";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { SectionHeader } from "./ReportsShared";

export const AgentDirectorySection = () => {
  const handleExport = async () => {
    try {
      const res = await axios.get(`${API}/reports/agents-export`, { withCredentials: true, responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `agents_directory_${new Date().toISOString().split("T")[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Agent directory exported");
    } catch {
      toast.error("Failed to export agents");
    }
  };

  return (
    <section data-testid="section-agents" id="section-agents">
      <SectionHeader icon={Users} title="Agent Directory" subtitle="Export buyer & seller agents from your transactions" />
      <Card className="card-surface">
        <CardContent className="py-8 flex flex-col items-center gap-3">
          <Users className="w-10 h-10" style={{ color: "var(--t-text-subtle)" }} />
          <p className="text-sm text-center max-w-md" style={{ color: "var(--t-text-muted)" }}>
            Download a CSV of all buyer and seller agents across your transactions — includes property address, name, email, and phone. Team members are automatically excluded.
          </p>
          <Button
            className="btn-primary mt-2"
            onClick={handleExport}
            data-testid="export-agents-btn"
          >
            <Download className="w-4 h-4 mr-2" /> Export Agent Directory
          </Button>
        </CardContent>
      </Card>
    </section>
  );
};
